module.exports = __webpack_public_path__ + "img/new_center.3ee1d507.png";